<template>
  <page>
    <div>
      <form>
        <v-flex xs12>
        <v-card>
          <v-card-text>
            <message :messages="messages"></message>
            <v-container fluid grid-list-lg>
              <v-layout row wrap>
                <v-flex xs12 md6>
                  <v-checkbox
                    v-model="form.useCoinsPct"
                    :label="labels.useCoinsPct"
                    :error-messages="errors.collect('useCoinsPct')"
                    data-vv-name="useCoinsPct"
                    :data-vv-as="labels.useCoinsPct"
                    v-validate="'required'"
                  ></v-checkbox>
                </v-flex>
                <v-flex xs12 md6>
                  <!-- <v-checkbox
                    v-model="form.genCCDoc"
                    :label="labels.genCCDoc"
                    :error-messages="errors.collect('genCCDoc')"
                    data-vv-name="genCCDoc"
                    :data-vv-as="labels.genCCDoc"
                    v-validate="'required'"
                  ></v-checkbox> -->
                </v-flex>
                <v-flex xs12 md6>
                  <cal-picker
                    v-model="form.tranDate"
                    :label="labels.tranDate"
                    :data-vv-as="labels.tranDate"
                    data-vv-name="tranDate"
                    :error-messages="errors.collect('tranDate')"
                    v-validate="'required|not_later_today'"
                  ></cal-picker>
                </v-flex>
                <v-flex xs12 md6>
                  <v-text-field
                    v-model="form.copy"
                    :label="labels.copy"
                    :error-messages="errors.collect('copy')"
                    data-vv-name="copy"
                    :data-vv-as="labels.copy"
                    v-validate="'required|numeric|min_value:1|max_value:10'"
                  ></v-text-field>
                </v-flex>
              </v-layout>
            </v-container>
          </v-card-text>
        </v-card>
        </v-flex>
        <v-spacer class="mt-2"></v-spacer>
        <v-flex xs12>
        <v-expansion-panels>
          <v-expansion-panel>
            <v-expansion-panel-header> <v-icon>mdi-filter-variant</v-icon>Filters </v-expansion-panel-header>
            <v-expansion-panel-content>
              <v-card>
                <v-card-text>
                  <v-container fluid grid-list-lg>
                    <v-layout row wrap>
                      <v-flex xs12 md6>
                        <v-text-field
                          v-model="form.clmNo"
                          :label="labels.clmNo"
                          :error-messages="errors.collect('')"
                          data-vv-name=""
                          :data-vv-as="labels.clmNo"
                          append-icon="mdi-magnify"
                          readonly
                          @click:append="multiclaimnolist = true"
                        ></v-text-field>
                      </v-flex>
                      <v-flex xs12 md6>
                        <v-text-field
                          v-model="form.branch"
                          :label="labels.branch"
                          :error-messages="errors.collect('branch')"
                          data-vv-name="branch"
                          :data-vv-as="labels.branch"
                          append-icon="mdi-magnify"
                          readonly
                          @click:append="multibranchlist = true"
                        ></v-text-field>
                      </v-flex>
                      <v-flex xs12 md6>
                        <v-text-field
                          v-model="form.fund"
                          :label="labels.fund"
                          :error-messages="errors.collect('fund')"
                          data-vv-name="fund"
                          :data-vv-as="labels.fund"
                          append-icon="mdi-magnify"
                          readonly
                          @click:append="multifundlist = true"
                        ></v-text-field>
                      </v-flex>
                      <v-flex xs12 md6>
                        <v-text-field
                          v-model="form.dept"
                          :label="labels.dept"
                          :error-messages="errors.collect('dept')"
                          data-vv-name="dept"
                          :data-vv-as="labels.dept"
                          append-icon="mdi-magnify"
                          readonly
                          @click:append="multideptlist = true"
                        ></v-text-field>
                      </v-flex>
                      <v-flex xs12 md6>
                        <v-text-field
                          v-model="form.inter"
                          :label="labels.inter"
                          :error-messages="errors.collect('inter')"
                          data-vv-name="inter"
                          :data-vv-as="labels.inter"
                          append-icon="mdi-magnify"
                          readonly
                          @click:append="multiinterlist = true"
                        ></v-text-field>
                      </v-flex>
                    </v-layout>
                  </v-container>
                </v-card-text>
              </v-card>
            </v-expansion-panel-content>
          </v-expansion-panel>
        </v-expansion-panels>
        </v-flex>
        <v-spacer class="mt-2"></v-spacer>
        <v-flex xs12>
        <v-expansion-panels v-model="toggleSetting" multiple>
          <v-expansion-panel>
            <v-expansion-panel-header> <v-icon>mdi-filter-variant</v-icon>Print Settings </v-expansion-panel-header>
            <v-expansion-panel-content>
              <v-card>
                <v-card-text>
                  <v-container fluid grid-list-lg>
                    <v-flex xs12 sm6 md6 lg6>
                        <v-autocomplete :items="sorts" v-model="form.sort" :label="labels.sort" item-text="label" item-value="value" data-vv-name="sort" :data-vv-as="labels.sort" :error-messages="errors.collect('sort')"></v-autocomplete>
                      </v-flex>
                  </v-container>
                </v-card-text>
              </v-card>
            </v-expansion-panel-content>
          </v-expansion-panel>
        </v-expansion-panels>
        </v-flex>
        <v-spacer class="mt-2"></v-spacer>
        <v-flex xs12>
          <v-btn :loading="loading" color="error" dark class=" mr-2" @click.prevent="doCancel"
            >{{ labels.cancel }}<v-icon dark right>mdi-cancel</v-icon></v-btn
          >
          <v-btn :loading="loading" color="primary" @click.prevent="doProcess"
            >{{ labels.submit }}<v-icon dark right>mdi-arrow-right-bold-box</v-icon></v-btn
          >
        </v-flex>
        <v-dialog v-model="multibranchlist" width="900px" persistent>
          <multi-branch-help-list :brn="form.branch" @close="doClose" @doAssign="doAssignBranch($event)"></multi-branch-help-list>
        </v-dialog>
        <v-dialog v-model="multifundlist" width="900px" persistent>
          <multi-fund-help-list :fnd="form.fund" @close="doClose" @doAssign="doAssignFund($event)"></multi-fund-help-list>
        </v-dialog>
        <v-dialog v-model="multideptlist" width="900px" persistent>
          <multi-dept-help-list :dept="form.dept" @close="doClose" @doAssign="doAssignDepartment($event)"></multi-dept-help-list>
        </v-dialog>
        <v-dialog v-model="multiinterlist" width="900px" persistent>
          <multi-intermediary-help-list :intr="form.inter" @close="doClose" @doAssign="doAssignIntermediary($event)"></multi-intermediary-help-list>
        </v-dialog>
        <v-dialog v-model="multiclaimnolist" width="900px" persistent>
          <multi-claim-no-help-list :clmNo="form.clmNo" @close="doClose" @doAssign="doAssignClaimNo($event)"></multi-claim-no-help-list>
        </v-dialog>
      </form>
    </div>
  </page>
</template>
<script>
import MessageMixin from '@/mixins/message'
import { removeTime } from '@/utils/date'
import isAfter from 'date-fns/isAfter'
import MultiBranchHelpList from '@/components/core/common/dialog/MultiBranchHelpList.vue'
import MultiFundHelpList from '@/components/core/common/dialog/MultiFundHelpList.vue'
import MultiDeptHelpList from '@/components/core/common/dialog/MultiDeptHelpList.vue'
import MultiIntermediaryHelpList from '@/components/core/common/dialog/MultiIntermediaryHelpList.vue'
import MultiClaimNoHelpList from './MultiClaimNoHelpList.vue'
export default {
  data() {
    return {
      labels: {
        useCoinsPct: 'Use Coinsurance % from Underwriting for Claims Debit Note Printing',
        genCCDoc: 'Generate Debit / Credit Notes for Cash Call',
        tranDate: 'Transaction Date',
        copy: 'No. of Copies',
        clmNo: 'Claim No.',
        branch: 'Branch',
        fund: 'Fund',
        dept: 'Department',
        inter: 'Suppress Printing only for the following Intermediaries',
        sort: 'Sort Debit / Credit Notes by',
        cancel: 'Cancel',
        submit: 'Submit'
      },
      sorts: [
        { label: '', value: null },
        { label: 'Claim No', value: true },
        { label: 'RI Company', value: false }
      ],
      form: {
        useCoinsPct: false,
        genCCDoc: false,
        tranDate: new Date(),
        copy: 1,
        clmNo: 'All',
        branch: 'All',
        fund: 'All',
        dept: 'All',
        inter: '',
        sort: null
      },
      multibranchlist: false,
      multifundlist: false,
      multideptlist: false,
      multiinterlist: false,
      multiclaimnolist: false,
      loading: false,
      toggleArray: [false],
      toggleSetting: [0]
    }
  },
  created() {
    this.init()
    this.$validator.extend('not_later_today', {
      getMessage(field, args) {
        return `Date cannot be later than System Date.`
      },
      validate(value, args) {
        if (value) {
          return !isAfter(removeTime(value), removeTime(new Date()))
        } else return true
      }
    })
  },
  mounted() {},
  computed: {
    menu() {
      return this.$store.state.claims.clmRIRcvy.menu
    }
  },
  watch: {},
  methods: {
    async init() {
      await this.$store.dispatch('clmRIRcvyInit')
    },
    doCancel() {
      this.$router.push({ name: 'specialFuncClm' })
    },
    doProcess() {
      this.resetMessages()
      this.$validator.validateAll().then((result) => {
        if (result) {
          this.process()
        }
      })
    },
    async process() {
      const apiUrl = this.menu.process
      this.resetMessages()
      if (apiUrl) {
        try {
          this.loading = true
          let expand = {
            useCoinsPct: this.form.useCoinsPct,
            genCCDoc: this.form.genCCDoc,
            tranDate: this.form.tranDate,
            copy: this.form.copy,
            clmNo: this.form.clmNo,
            branch: this.form.branch,
            fund: this.form.fund,
            dept: this.form.dept,
            inter: this.form.inter,
            sort: this.form.sort
          }
          const result = await this.$http.post(apiUrl, expand)
          if (result) {
            this.$toast.success('Job successfully submitted to batch job process.')
            this.doCancel()
          }
        } catch (err) {
          const { data } = err.response
          if (data) {
            this.message(data)
          }
          this.loading = false
        }
      } else {
        this.loading = false
        this.errorMessage('The request failed because it is trying to execute an invalid API url.')
      }
    },
    async doAssignBranch(Obj) {
      this.form.branch = []
      this.form.branch = Obj.finalSelectedItems.toString()
    },
    async doAssignFund(Obj) {
      this.form.fund = []
      this.form.fund = Obj.finalSelectedItems.toString()
    },
    async doAssignDepartment(Obj) {
      this.form.dept = []
      this.form.dept = Obj.finalSelectedItems.toString()
    },
    async doAssignIntermediary(Obj) {
      this.form.inter = []
      this.form.inter = Obj.finalSelectedItems.toString()
    },
    async doAssignClaimNo(Obj) {
      this.form.clmNo = []
      this.form.clmNo = Obj.finalSelectedItems.toString()
    },
    doClose() {
      this.multibranchlist = false
      this.multifundlist = false
      this.multideptlist = false
      this.multiinterlist = false
      this.multiclaimnolist = false
    }
  },
  mixins: [MessageMixin],
  components: { MultiBranchHelpList, MultiFundHelpList, MultiDeptHelpList, MultiIntermediaryHelpList, MultiClaimNoHelpList }
}
</script>
